import React, { useEffect, useState } from "react";
import {
  TextInput,
  Row,
  Column,
  FormGroup,
  TextArea,
  RadioButtonGroup,
  RadioButton,
} from "carbon-components-react";
import useGet from "../../hooks/useGet";
import useAuth from "../../hooks/useAuth";
import GenericCombo from "../Combos/GenericCombo";
import ProvinceCombo from "../Combos/ProvinceCombo";
import DistrictCombo from "../Combos/DistrictCombo";
import { toast } from "react-toastify";
import http from "../../http-common";

const DataSheetForm = ({
  disabled,
  register,
  control,
  errors,
  hasBusinessCurrently,
  setHasBusinessCurrently,
  businessPlan,
}) => {
  const { data: addressTypes } = useGet("/utils/address-types");
  const [districts, setDistricts] = useState([]);
  const { isCompetitor } = useAuth();

  const handleHasBusinessCurrently = (e) => {
    setHasBusinessCurrently(e);
  };

  const getDistricts = async (provinceId) => {
    if (provinceId) {
      try {
        const response = await http.get(
          "/utils/provinces/" + provinceId + "/districts"
        );
        setDistricts(response.data);
      } catch (error) {
        toast.error(error?.response?.data.message);
      }
    } else {
      setDistricts([]);
    }
  };

  useEffect(() => {
    if (businessPlan) {
      getDistricts(businessPlan.provinceId);
    }
  }, [businessPlan]);

  return (
    <FormGroup legendText="1. FICHA TÉCNICA" className="section-header">
      <fieldset className="bx--fieldset">
        <Row>
          <Column xml={12} sm={6} md={4} lg={4} className="required">
            <TextInput
              labelText="1.1	Numero Único de Referência (NUR)"
              id="nur"
              maxLength={12}
              disabled={true}
              {...register("nur")}
            />
            <p className="field-error">{errors.nur?.message}</p>
          </Column>
        </Row>
      </fieldset>
      <fieldset className="bx--fieldset">
        <legend className="bx--label">
          1.2 Endereço de domicílio de negócio /residência
        </legend>
        <Row>
          <Column xml={12} sm={6} md={3} lg={3} className="required">
            <ProvinceCombo
              id="provinceId"
              name="provinceId"
              label="Província"
              disabled={disabled}
              control={control}
              setDistricts={setDistricts}
            />
            <p className="field-error">{errors.provinceId?.message}</p>
          </Column>

          <Column xml={12} sm={6} md={3} lg={3} className="required">
            <DistrictCombo
              id="districtId"
              name="districtId"
              label="Cidade/Distrito"
              disabled={disabled}
              items={districts}
              control={control}
            />
            <p className="field-error">{errors.districtId?.message}</p>
          </Column>
          <Column xml={12} sm={6} md={3} lg={3} className="required">
            <TextInput
              id="administrativePost"
              labelText="Posto Administrativo"
              maxLength={128}
              disabled={disabled}
              {...register("administrativePost")}
            />
            <p className="field-error">{errors.administrativePost?.message}</p>
          </Column>
          <Column xml={12} sm={6} md={3} lg={3} className="required">
            <TextInput
              id="locality"
              labelText="Localidade"
              maxLength={128}
              disabled={disabled}
              {...register("locality")}
            />
            <p className="field-error">{errors.locality?.message}</p>
          </Column>
        </Row>
        <Row>
          <Column xml={12} sm={6} md={6} lg={6} className="required">
            <TextInput
              id="neighborhood"
              labelText="Bairro"
              maxLength={128}
              disabled={disabled}
              {...register("neighborhood")}
            />
            <p className="field-error">{errors.neighborhood?.message}</p>
          </Column>
          <Column xml={12} sm={6} md={3} lg={3} className="required">
            <GenericCombo
              id="addressTypeCode"
              name="addressTypeCode"
              label="O endereço registado é do/a"
              disabled={disabled}
              register={register}
              items={addressTypes}
            />
            <p className="field-error">{errors.addressTypeCode?.message}</p>
          </Column>
        </Row>
      </fieldset>
      <fieldset fieldset className="bx--fieldset">
        <Row>
          <Column xsm={12} sm={12} md={12} lg={12} className="required">
            <TextArea
              id="partnersQualifications"
              labelText="1.3	Experiência e qualificação dos sócios-gestores/sócias-gestoras"
              rows={10}
              disabled={disabled}
              helperText="[Descreva de forma breve, sem destacar o(s) nome(s), o perfil dos/as seus(as) sócios/as, considerando: (i) formação académica/vocacional  e (ii) número de anos de experiência profissional na área para a qual é apresentado este plano de negócio. Use no máximo 100 palavras.]"
              {...register("partnersQualifications")}
            />
            <p className="field-error">
              {errors.partnersQualifications?.message}
            </p>
          </Column>
        </Row>
      </fieldset>

      <fieldset className="bx--fieldset required" style={{ marginBottom: "0" }}>
        <legend className="bx--label">1.4 Tem um negócio actualmente?</legend>
        <Row>
          <Column>
            <RadioButtonGroup
              name="hasBusinessCurrently"
              disabled={disabled}
              onChange={handleHasBusinessCurrently}
              valueSelected={hasBusinessCurrently}
            >
              <RadioButton
                labelText="Sim. Preencha a secção 2 e a secção 3"
                value="Sim"
                id="section-c"
                {...register("hasBusinessCurrently")}
              />
              <RadioButton
                labelText="Não. Prossiga para a secção 3"
                value="Não"
                id="section-d"
                {...register("hasBusinessCurrently")}
              />
            </RadioButtonGroup>
            <p className="field-error">
              {errors.hasBusinessCurrently?.message}
            </p>
          </Column>
        </Row>
      </fieldset>
    </FormGroup>
  );
};

DataSheetForm.defaultProps = {
  disabled: false,
};

export default DataSheetForm;
